import type { BaseResponse, PaginatedResponse } from './base';
import type { Role } from '~/models/role';
import type { AdminRole } from '~/models/admin-role';

export enum AccountType {
  SYSTEM_MANAGER = 'system_manager',
  ORGANIZATION_MANAGER = 'organization_manager',
  SHOP_MANAGER = 'shop_manager',
  SHOP_STAFF = 'shop_staff',
}

// The higher the number, the higher the priority
export const AccountTypePriority = {
  [AccountType.SYSTEM_MANAGER]: 4,
  [AccountType.ORGANIZATION_MANAGER]: 3,
  [AccountType.SHOP_MANAGER]: 2,
  [AccountType.SHOP_STAFF]: 1,
};

export interface Operator {
  id: number;
  uid: string;
  organization_id: number;
  name: string;
  email: string;
  password: string;
  passcode: string;
  role: Role;
  role_id: number;
  admin_role?: AdminRole | null;
  // Request only. The response sends `admin_role`.
  admin_role_uid?: string;
  account_type: AccountType;
  invitation_pending?: boolean;
  manageable_shop_ids?: number[];
  shops?: Shop[];
}

export interface OperatorListResponse extends PaginatedResponse<Operator> {}

export interface OperatorResponse extends BaseResponse<Operator> {}

export interface GeneratePasscodeResponse extends BaseResponse<{ passcode: string }> {}
